const colors = {
  accent: {
    green: '#DFFF31',
    pink: '#FF3B90',
    orange: '#FFA200',
    lightBlue: '#1dbad6',
    blue: '#5468FF',
  },  
  gradient: {
    darkNavy: '#21243D',
    lightNavy: '#3A406E',
  },
  typography: {
    headerLight: '#fff',
    headerDark: '#2e4a82',
    textLight: '#fff',
    textDark: '#868BAF',
    textBlue: '#1dbad6', // card
  },
  bg: {
    cardDarkNavy: '#111A2C',
    white: '#fff'
  }
}

export default colors

// --bg-grad-dark: #21243D; // navy
// --bg-grad-light: #3A406E;
// --bg-dark-blue: #121B2C; // dark navy
// --bg-light-blue: #3A416F; // lighter navy
// --bg-dark-navy: #111A2C; // card dark bg